import React from 'react';

export const RadarChart = ({ data, labels, maxValue = 5, width = 300, height = 260 }) => {
    const centerX = width / 2;
    const centerY = height / 2;
    const radius = Math.min(width, height) / 2 - 40; // padding uz najmanju dimenziju
    const angleStep = (Math.PI * 2) / labels.length;

    const getPoint = (value, index, scale = 1) => {
        const angle = index * angleStep - Math.PI / 2;
        const r = (value / maxValue) * radius * scale;
        return [
            centerX + r * Math.cos(angle),
            centerY + r * Math.sin(angle)
        ];
    };

    // Grid layers
    const gridLayers = [];
    for (let i = 1; i <= maxValue; i++) {
        const points = labels.map((_, idx) => getPoint(i, idx, 1))
            .map(p => p.join(','))
            .join(' ');
        gridLayers.push(
            <polygon
                key={`grid-${i}`}
                points={points}
                fill='none'
                stroke='#555'
                strokeWidth='1'
                opacity={0.5}
            />
        );
    }

    // Data polygon
    const dataPoints = labels.map((_, idx) => getPoint(data[idx], idx))
        .map(p => p.join(','))
        .join(' ');

    // Labels
    const labelElements = labels.map((label, idx) => {
        const angle = idx * angleStep - Math.PI / 2;
        const r = radius + 20;
        const x = centerX + r * Math.cos(angle);
        const y = centerY + r * Math.sin(angle);

        let anchor = 'middle';
        if (Math.cos(angle) > 0.1) anchor = 'start';
        else if (Math.cos(angle) < -0.1) anchor = 'end';

        return (
            <text
                key={label}
                x={x}
                y={y}
                fill='#fff'
                fontSize='14'
                textAnchor={anchor}
                dominantBaseline='middle'
            >
                {label}
            </text>
        );
    });

    const spokes = labels.map((_, idx) => {
        const [x, y] = getPoint(maxValue, idx);
        return (
            <line
                key={`spoke-${idx}`}
                x1={centerX}
                y1={centerY}
                x2={x}
                y2={y}
                stroke='#555'
                strokeWidth='1'
                opacity={0.5}
            />
        );
    });

    return (
        <svg width={width} height={height}>
            <defs>
                <linearGradient opacity={.2} id='orangeGradient' x1='0%' y1='0%' x2='0%' y2='100%'>
                    <stop offset='0%' stopColor='#ff9900' />
                    <stop offset='100%' stopColor='#0F0F0F' />
                </linearGradient>
            </defs>

            {spokes}
            {gridLayers}

            <polygon
                points={dataPoints}
                fill='url(#orangeGradient)'
                stroke='orange'
                strokeWidth='1'
                opacity={0.5}
            />

            {labelElements}
        </svg>
    );
};